import { render } from "./GuiTinkoffTaxationSelect.vue?vue&type=template&id=ab52e8f0"
import script from "./GuiTinkoffTaxationSelect.vue?vue&type=script&lang=js"
export * from "./GuiTinkoffTaxationSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__